<!--ODP is no longer supported / only here for legacy documents-->
@if (getType() === "ODP") {
	<sim-odp-viewer [media]="media" />
}

@if (getType() === "PPTX") {
	<sim-pptx-viewer
		[file]="file"
		[media]="media"
		[pageNum]="pageNum"
		[enableAutoPlay]="enableAutoPlay"
		[autoPlayInterval]="autoPlayInterval"
		[width]="width"
		[height]="height"
		[autoSize]="autoSize"
		(loaded)="loaded.emit($event)"
		(numberOfPages)="numberOfPages.emit($event)"
		(loadingError)="loadingError.emit($event)"
	/>
}
